/**
 * LSDN Fragrance Quiz — data only (no scoring engine).
 * French locale variant — questions and answers only.
 * Source: QUIZ MAPPING 15052026
 *
 * Global: window.LsdnQuizData
 * Engine: assets/lsdn-quiz-engine.js (separate, not included here)
 */

function score(fragranceId, points) {
  return { fragranceId, points };
}

const LsdnQuizData = {
  "version": "2026-05-15",
  "meta": {
    "scoring": {
      "pointsStrongest": 3,
      "pointsStrong": 2,
      "pointsLight": 1,
      "primaryResult": "highest_total_score",
      "secondaryResult": "next_strongest_with_compatibility_rules"
    },
    "questionWeights": {
      "how-do-you-want-to-feel": 1.8,
      "your-presence-usually-feels": 1.5,
      "what-people-remember": 1.3,
      "choose-an-atmosphere": 1.1,
      "fragrance-world": 1
    },
    "tiebreaker": {
      "description": "When two fragrances tie, resolve by weighted Q1 contribution, then Q2, then Q5, then luxuryProfileOrder.",
      "priority": [
        {
          "source": "question",
          "questionId": "how-do-you-want-to-feel",
          "reason": "strongest_emotional_indicator"
        },
        {
          "source": "question",
          "questionId": "your-presence-usually-feels",
          "reason": "presence_identity"
        },
        {
          "source": "question",
          "questionId": "fragrance-world",
          "reason": "fragrance_world_preference"
        },
        {
          "source": "luxury_profile_order",
          "reason": "elegant_luxury_emotional_profile"
        }
      ],
      "luxuryProfileOrder": [
        "call-me-iris",
        "midnight-call",
        "oud-rose",
        "nomad-soul",
        "pear-addiction",
        "clandestine-rendez-vous",
        "amazing-jade",
        "saffron-flower",
        "mitsio-vanille",
        "forbidden-nectar",
        "citrus-poetry",
        "neon-splash",
        "cuir-noir",
        "cherry-blush",
        "bohemian-absinthe",
        "red-berries-elixir",
        "jardin-de-macarons"
      ]
    },
    "secondaryMatch": {
      "dayNightRule": {
        "description": "If primary is night-dominant, second should preferably be flexible or an elegant night-dominant fragrance.",
        "nightPrimaryPrefer": [
          "flexible",
          "night"
        ],
        "avoidPairing": "two_extremely_heavy_dark_fragrances"
      },
      "heavyPairsToLimit": [
        [
          "midnight-call",
          "cuir-noir"
        ],
        [
          "oud-rose",
          "clandestine-rendez-vous"
        ]
      ],
      "rotation": {
        "description": "Deprioritize overused pairs when scores are close.",
        "frequentPairs": [
          {
            "primaryId": "pear-addiction",
            "overusedSecondId": "midnight-call",
            "alternativeSecondIds": [
              "forbidden-nectar",
              "cherry-blush",
              "mitsio-vanille"
            ]
          },
          {
            "primaryId": "citrus-poetry",
            "overusedSecondId": "neon-splash",
            "alternativeSecondIds": [
              "call-me-iris",
              "bohemian-absinthe",
              "mitsio-vanille"
            ]
          }
        ]
      },
      "similarProfiles": [
        {
          "groupId": "fruity-gourmand",
          "fragranceIds": [
            "pear-addiction",
            "red-berries-elixir",
            "forbidden-nectar",
            "jardin-de-macarons"
          ],
          "note": "Avoid pairing two from this group when scores are close."
        }
      ]
    },
    "profileLabels": {
      "placement": "above_results_heading",
      "description": "Optional premium identity labels (engine derives from result pair).",
      "examples": [
        "Magnetic Sophisticate",
        "Dark Sensuality",
        "Modern Addictive Energy",
        "Radiant Elegance",
        "Quiet Luxury Presence",
        "Warm Magnetic Soul",
        "Artistic Freedom",
        "Timeless Seduction"
      ]
    }
  },
  "fragrances": {
    "nomad-soul": {
      "id": "nomad-soul",
      "name": "Nomad Soul",
      "profile": "Warm Woody Floral",
      "emotions": [
        "soulful",
        "refined",
        "elegant",
        "mysterious",
        "grounded"
      ],
      "idealFor": "elegant personalities, evenings, understated luxury",
      "intensity": "strong with character",
      "usage": "flexible"
    },
    "call-me-iris": {
      "id": "call-me-iris",
      "name": "Call Me Iris",
      "profile": "Powdery Elegant Iris",
      "emotions": [
        "timeless",
        "elegant",
        "sophisticated",
        "graceful",
        "soft luxury"
      ],
      "energy": "clean refined elegance",
      "idealFor": "quiet sophistication, chic personalities, signature elegance",
      "intensity": "noticeable",
      "usage": "day"
    },
    "amazing-jade": {
      "id": "amazing-jade",
      "name": "Amazing Jade",
      "profile": "Oriental Gourmand",
      "emotions": [
        "mysterious",
        "luxurious",
        "sensual",
        "warm",
        "rich"
      ],
      "energy": "golden luxury evenings",
      "intensity": "strong",
      "usage": "night"
    },
    "saffron-flower": {
      "id": "saffron-flower",
      "name": "Saffron Flower",
      "profile": "Spicy Oriental",
      "emotions": [
        "bold",
        "sensual",
        "warm woody",
        "intense",
        "seductive"
      ],
      "energy": "powerful attraction",
      "intensity": "strong magnetic",
      "usage": "flexible"
    },
    "pear-addiction": {
      "id": "pear-addiction",
      "name": "Pear Addiction",
      "profile": "Fruity Gourmand",
      "emotions": [
        "addictive",
        "magnetic",
        "vibrant",
        "sensual",
        "modern"
      ],
      "energy": "attention magnet",
      "intensity": "noticeable to strong",
      "usage": "flexible"
    },
    "mitsio-vanille": {
      "id": "mitsio-vanille",
      "name": "Mitsio Vanille",
      "profile": "Vanilla Musk Fresh",
      "emotions": [
        "comforting",
        "elegant",
        "addictive",
        "warm",
        "soft sensuality"
      ],
      "energy": "warm cocoon",
      "intensity": "noticeable elegant",
      "usage": "flexible"
    },
    "citrus-poetry": {
      "id": "citrus-poetry",
      "name": "Citrus Poetry",
      "profile": "Fresh Citrus",
      "emotions": [
        "bright",
        "refined",
        "fresh",
        "radiant",
        "energetic"
      ],
      "energy": "uplifted Mediterranean luxury",
      "intensity": "noticeable",
      "usage": "day"
    },
    "midnight-call": {
      "id": "midnight-call",
      "name": "Midnight Call",
      "profile": "Powdery Elegant Dark",
      "emotions": [
        "mysterious",
        "magnetic",
        "elegant",
        "sensual",
        "deep"
      ],
      "energy": "night sophistication",
      "intensity": "strong elegant",
      "usage": "night"
    },
    "oud-rose": {
      "id": "oud-rose",
      "name": "Oud Rose",
      "profile": "Spicy Oriental Oud Rose",
      "emotions": [
        "sophisticated",
        "powerful and warm",
        "luxurious",
        "sensual",
        "refined"
      ],
      "energy": "royal elegance",
      "intensity": "strong",
      "usage": "night"
    },
    "forbidden-nectar": {
      "id": "forbidden-nectar",
      "name": "Forbidden Nectar",
      "profile": "Powdery Fruity",
      "emotions": [
        "sensual",
        "magnetic",
        "addictive",
        "seductive",
        "modern"
      ],
      "energy": "soft sensual magnetism",
      "intensity": "noticeable",
      "usage": "flexible"
    },
    "red-berries-elixir": {
      "id": "red-berries-elixir",
      "name": "Red Berries Elixir",
      "profile": "Fruity Gourmand",
      "emotions": [
        "joyful",
        "vibrant",
        "addictive",
        "playful",
        "energetic"
      ],
      "energy": "happy confidence",
      "intensity": "noticeable",
      "usage": "flexible"
    },
    "cherry-blush": {
      "id": "cherry-blush",
      "name": "Cherry Blush",
      "profile": "Fruity Woody",
      "emotions": [
        "bold",
        "sensual",
        "modern",
        "edgy",
        "confident"
      ],
      "energy": "sexy modernity",
      "intensity": "strong",
      "usage": "flexible"
    },
    "cuir-noir": {
      "id": "cuir-noir",
      "name": "Cuir Noir",
      "profile": "Leather Spicy Floral",
      "emotions": [
        "dark",
        "elegant",
        "powerful",
        "mysterious",
        "intense"
      ],
      "energy": "dominant sophistication",
      "intensity": "strong",
      "usage": "night"
    },
    "jardin-de-macarons": {
      "id": "jardin-de-macarons",
      "name": "Jardin de Macarons",
      "profile": "Gourmand",
      "emotions": [
        "comforting",
        "playful",
        "cozy",
        "joyful",
        "delicious"
      ],
      "energy": "soft happiness",
      "intensity": "noticeable",
      "usage": "flexible"
    },
    "bohemian-absinthe": {
      "id": "bohemian-absinthe",
      "name": "Bohemian Absinthe",
      "profile": "Aromatic Green",
      "emotions": [
        "artistic",
        "elegant",
        "free",
        "fresh",
        "unconventional"
      ],
      "energy": "creative freedom",
      "intensity": "noticeable refined",
      "usage": "day"
    },
    "clandestine-rendez-vous": {
      "id": "clandestine-rendez-vous",
      "name": "Clandestine Rendez-Vous",
      "profile": "Amber Addictive",
      "emotions": [
        "deep",
        "sensual",
        "mysterious",
        "addictive",
        "intimate"
      ],
      "energy": "dark intimacy",
      "intensity": "strong",
      "usage": "night"
    },
    "neon-splash": {
      "id": "neon-splash",
      "name": "Neon Splash",
      "profile": "Citrus Floral Fresh",
      "emotions": [
        "luminous",
        "elegant",
        "radiant",
        "energetic",
        "modern"
      ],
      "energy": "bright sophistication",
      "intensity": "noticeable",
      "usage": "day"
    }
  },
  "compatibilityMatrix": {
    "pear-addiction": {
      "allowedSecondIds": [
        "midnight-call",
        "forbidden-nectar",
        "cherry-blush",
        "mitsio-vanille"
      ],
      "avoidSecondIds": [
        "red-berries-elixir"
      ],
      "note": "Too redundant fruity gourmand profile."
    },
    "call-me-iris": {
      "allowedSecondIds": [
        "oud-rose",
        "midnight-call",
        "mitsio-vanille",
        "nomad-soul"
      ],
      "avoidSecondIds": [
        "neon-splash"
      ],
      "note": "Emotionally too disconnected."
    },
    "midnight-call": {
      "allowedSecondIds": [
        "clandestine-rendez-vous",
        "pear-addiction",
        "oud-rose",
        "call-me-iris"
      ],
      "avoidSecondIds": [
        "jardin-de-macarons"
      ],
      "note": "Too disconnected emotionally."
    },
    "oud-rose": {
      "allowedSecondIds": [
        "cuir-noir",
        "midnight-call",
        "nomad-soul",
        "amazing-jade"
      ],
      "avoidSecondIds": [
        "neon-splash"
      ]
    },
    "citrus-poetry": {
      "allowedSecondIds": [
        "neon-splash",
        "call-me-iris",
        "bohemian-absinthe"
      ],
      "avoidSecondIds": [
        "cuir-noir"
      ]
    },
    "mitsio-vanille": {
      "allowedSecondIds": [
        "call-me-iris",
        "pear-addiction",
        "forbidden-nectar",
        "jardin-de-macarons"
      ],
      "avoidSecondIds": [
        "cuir-noir"
      ]
    },
    "clandestine-rendez-vous": {
      "allowedSecondIds": [
        "midnight-call",
        "oud-rose",
        "pear-addiction",
        "amazing-jade"
      ],
      "avoidSecondIds": [
        "neon-splash"
      ]
    },
    "bohemian-absinthe": {
      "allowedSecondIds": [
        "mitsio-vanille",
        "citrus-poetry",
        "nomad-soul",
        "call-me-iris"
      ],
      "avoidSecondIds": [
        "cuir-noir"
      ]
    }
  },
  "usageByType": {
    "day": [
      "citrus-poetry",
      "neon-splash",
      "call-me-iris",
      "bohemian-absinthe"
    ],
    "night": [
      "midnight-call",
      "clandestine-rendez-vous",
      "cuir-noir",
      "amazing-jade",
      "oud-rose"
    ],
    "flexible": [
      "pear-addiction",
      "mitsio-vanille",
      "forbidden-nectar",
      "cherry-blush",
      "red-berries-elixir",
      "saffron-flower",
      "nomad-soul",
      "jardin-de-macarons"
    ]
  },
  "fragranceIds": [
    "nomad-soul",
    "call-me-iris",
    "amazing-jade",
    "saffron-flower",
    "pear-addiction",
    "mitsio-vanille",
    "citrus-poetry",
    "midnight-call",
    "oud-rose",
    "forbidden-nectar",
    "red-berries-elixir",
    "cherry-blush",
    "cuir-noir",
    "jardin-de-macarons",
    "bohemian-absinthe",
    "clandestine-rendez-vous",
    "neon-splash"
  ]
};

LsdnQuizData.questions = [
  {
    id: 'how-do-you-want-to-feel',
    order: 1,
    label: "Comment souhaitez-vous vous sentir ?",
    instruction: 'Choisissez une réponse',
    weight: 1.8,
    answers: [
    {
      id: 'magnetic',
      label: "Magnétique",
      scores: [score('pear-addiction', 3), score('midnight-call', 3), score('forbidden-nectar', 2), score('clandestine-rendez-vous', 2), score('cherry-blush', 1)],
    },
    {
      id: 'elegant',
      label: "Élégant",
      scores: [score('call-me-iris', 3), score('oud-rose', 3), score('midnight-call', 2), score('citrus-poetry', 2), score('nomad-soul', 1)],
    },
    {
      id: 'addictive',
      label: "Addictif",
      scores: [score('pear-addiction', 3), score('mitsio-vanille', 3), score('red-berries-elixir', 3), score('clandestine-rendez-vous', 2), score('forbidden-nectar', 1)],
    },
    {
      id: 'fresh',
      label: "Frais",
      scores: [score('citrus-poetry', 3), score('neon-splash', 3), score('bohemian-absinthe', 2), score('mitsio-vanille', 2)],
    },
    {
      id: 'mysterious',
      label: "Mystérieux",
      scores: [score('midnight-call', 3), score('clandestine-rendez-vous', 3), score('oud-rose', 3), score('nomad-soul', 2), score('cuir-noir', 2), score('amazing-jade', 1)],
    },
    {
      id: 'comforted',
      label: "Réconforté",
      scores: [score('mitsio-vanille', 3), score('midnight-call', 3), score('call-me-iris', 2)],
    },
    {
      id: 'powerful',
      label: "Puissant",
      scores: [score('oud-rose', 3), score('cuir-noir', 3), score('saffron-flower', 2), score('cherry-blush', 2)],
    },
    {
      id: 'free',
      label: "Libre",
      scores: [score('bohemian-absinthe', 3), score('citrus-poetry', 3), score('neon-splash', 2), score('mitsio-vanille', 2), score('nomad-soul', 1)],
    },
    {
      id: 'sophisticated',
      label: "Sophistiqué",
      scores: [score('call-me-iris', 3), score('midnight-call', 3), score('oud-rose', 2), score('cuir-noir', 2), score('nomad-soul', 1)],
    },
    {
      id: 'joyful',
      label: "Rayonnant",
      scores: [score('red-berries-elixir', 3), score('pear-addiction', 3), score('neon-splash', 2), score('jardin-de-macarons', 1)],
    }
    ],
  },
  {
    id: 'your-presence-usually-feels',
    order: 2,
    label: "Votre présence est plutôt...",
    instruction: 'Choisissez une réponse',
    weight: 1.5,
    answers: [
    {
      id: 'quiet-but-unforgettable',
      label: "Discrète mais inoubliable",
      scores: [score('call-me-iris', 3), score('pear-addiction', 3), score('midnight-call', 2)],
    },
    {
      id: 'warm-and-comforting',
      label: "Chaleureuse et réconfortante",
      scores: [score('midnight-call', 3), score('forbidden-nectar', 3), score('cherry-blush', 2)],
    },
    {
      id: 'bright-and-energetic',
      label: "Lumineuse et énergisante",
      scores: [score('citrus-poetry', 3), score('neon-splash', 3), score('red-berries-elixir', 2)],
    },
    {
      id: 'deep-and-intense',
      label: "Profonde et intense",
      scores: [score('clandestine-rendez-vous', 3), score('cuir-noir', 3), score('oud-rose', 2), score('midnight-call', 2), score('nomad-soul', 1)],
    },
    {
      id: 'elegant-and-refined',
      label: "Élégante et raffinée",
      scores: [score('call-me-iris', 3), score('oud-rose', 3), score('midnight-call', 2), score('nomad-soul', 1)],
    },
    {
      id: 'playful-and-addictive',
      label: "Joyeuse et irrésistible",
      scores: [score('pear-addiction', 3), score('red-berries-elixir', 3), score('forbidden-nectar', 2)],
    },
    {
      id: 'clean-and-fresh',
      label: "Pure et fraîche",
      scores: [score('citrus-poetry', 3), score('neon-splash', 3), score('bohemian-absinthe', 2)],
    },
    {
      id: 'seductive-and-mysterious',
      label: "Séduisante et mystérieuse",
      scores: [score('midnight-call', 3), score('clandestine-rendez-vous', 3), score('cherry-blush', 2), score('saffron-flower', 2), score('amazing-jade', 1)],
    }
    ],
  },
  {
    id: 'what-people-remember',
    order: 3,
    label: "Que retiennent les autres de vous ?",
    instruction: 'Choisissez une réponse',
    weight: 1.3,
    answers: [
    {
      id: 'my-elegance',
      label: "Mon élégance",
      scores: [score('call-me-iris', 3), score('oud-rose', 2), score('nomad-soul', 1)],
    },
    {
      id: 'my-energy',
      label: "Mon énergie",
      scores: [score('neon-splash', 3), score('citrus-poetry', 3), score('red-berries-elixir', 2)],
    },
    {
      id: 'my-softness',
      label: "Ma douceur",
      scores: [score('mitsio-vanille', 3), score('call-me-iris', 3), score('jardin-de-macarons', 2)],
    },
    {
      id: 'my-mystery',
      label: "Mon mystère",
      scores: [score('midnight-call', 3), score('cuir-noir', 3), score('clandestine-rendez-vous', 2), score('nomad-soul', 1)],
    },
    {
      id: 'my-confidence',
      label: "Mon assurance",
      scores: [score('oud-rose', 3), score('cherry-blush', 3), score('saffron-flower', 2)],
    },
    {
      id: 'my-warmth',
      label: "Ma chaleur",
      scores: [score('midnight-call', 3), score('forbidden-nectar', 3), score('cherry-blush', 2)],
    },
    {
      id: 'my-uniqueness',
      label: "Ma singularité",
      scores: [score('bohemian-absinthe', 3), score('mitsio-vanille', 3), score('forbidden-nectar', 2)],
    },
    {
      id: 'my-sensuality',
      label: "Ma sensualité",
      scores: [score('pear-addiction', 3), score('forbidden-nectar', 3), score('midnight-call', 2), score('clandestine-rendez-vous', 2), score('saffron-flower', 1)],
    }
    ],
  },
  {
    id: 'choose-an-atmosphere',
    order: 4,
    label: "Choisissez une atmosphère",
    instruction: 'Choisissez une réponse',
    weight: 1.1,
    answers: [
    {
      id: 'golden-sunset-marrakech',
      label: "Un coucher de soleil doré à Marrakech",
      scores: [score('amazing-jade', 3), score('oud-rose', 3), score('saffron-flower', 2)],
    },
    {
      id: 'silent-luxury-hotel',
      label: "Un hôtel de luxe empreint de sérénité",
      scores: [score('call-me-iris', 3), score('midnight-call', 3), score('bohemian-absinthe', 2)],
    },
    {
      id: 'summer-mediterranean',
      label: "Un été sur la côte méditerranéenne",
      scores: [score('citrus-poetry', 3), score('neon-splash', 3), score('mitsio-vanille', 2)],
    },
    {
      id: 'candlelight-dinner',
      label: "Un dîner à la lueur des bougies",
      scores: [score('clandestine-rendez-vous', 3), score('midnight-call', 3), score('pear-addiction', 2), score('amazing-jade', 1)],
    },
    {
      id: 'fresh-white-linen',
      label: "Du linge blanc fraîchement lavé",
      scores: [score('call-me-iris', 3), score('citrus-poetry', 3), score('neon-splash', 2), score('mitsio-vanille', 1)],
    },
    {
      id: 'paris-at-night',
      label: "Paris à la nuit tombée",
      scores: [score('midnight-call', 3), score('clandestine-rendez-vous', 3), score('bohemian-absinthe', 2), score('oud-rose', 2)],
    },
    {
      id: 'wild-nature-escape',
      label: "Une escapade au cœur de la nature",
      scores: [score('bohemian-absinthe', 3), score('mitsio-vanille', 3), score('neon-splash', 2)],
    },
    {
      id: 'artistic-hidden-cafe',
      label: "Un café confidentiel et inspirant",
      scores: [score('clandestine-rendez-vous', 3), score('bohemian-absinthe', 3), score('midnight-call', 2)],
    }
    ],
  },
  {
    id: 'fragrance-world',
    order: 5,
    label: "Quel univers olfactif vous attire le plus ?",
    instruction: 'Choisissez une réponse',
    weight: 1,
    answers: [
    {
      id: 'fruity-gourmand',
      label: "Fruité Gourmand",
      scores: [score('pear-addiction', 3), score('red-berries-elixir', 3), score('forbidden-nectar', 2)],
    },
    {
      id: 'warm-woody-floral',
      label: "Floral Boisé Chaleureux",
      scores: [score('oud-rose', 3), score('cherry-blush', 2), score('nomad-soul', 1)],
    },
    {
      id: 'powdery-elegant-iris',
      label: "Iris Poudré Élégant",
      scores: [score('call-me-iris', 3), score('midnight-call', 3), score('forbidden-nectar', 2)],
    },
    {
      id: 'spicy-oriental',
      label: "Oriental Épicé",
      scores: [score('oud-rose', 3), score('amazing-jade', 2), score('saffron-flower', 1)],
    },
    {
      id: 'citrus-fresh',
      label: "Agrumes Frais",
      scores: [score('citrus-poetry', 3), score('neon-splash', 3)],
    },
    {
      id: 'aromatic-green',
      label: "Aromatique Vert",
      scores: [score('bohemian-absinthe', 3)],
    },
    {
      id: 'amber-addictive',
      label: "Ambré Addictif",
      scores: [score('clandestine-rendez-vous', 3)],
    },
    {
      id: 'vanilla-musk',
      label: "Vanille Musquée",
      scores: [score('mitsio-vanille', 3), score('call-me-iris', 2)],
    },
    {
      id: 'leather-spicy',
      label: "Cuir Épicé",
      scores: [score('cuir-noir', 3)],
    },
    {
      id: 'woody-fruity',
      label: "Boisé Fruité",
      scores: [score('cherry-blush', 3)],
    }
    ],
  }
];

window.LsdnQuizData = LsdnQuizData;
